import {createApp} from 'vue'
import Store from 'store'
import CustomerInfo from './CustomerInfo'
import DeliveryInfo from './DeliveryInfo'

const el = '.nlx-component--customer-info'
const elDeli = '.nlx-component--delivery-info'
const DOM = document.querySelector(el)
const DOMDeli = document.querySelector(elDeli)

if(DOM){
    const fields = JSON.parse(DOM.dataset.fields || '')
    const countryList = JSON.parse(DOM.dataset.countrylist || '')
    const disabled = DOM.dataset.disabled === 'true'
    const component = createApp(CustomerInfo,{fields,formName:'customerInfo',countryList,disabled}).use(Store)
    const componentDeli = createApp(DeliveryInfo,{countryList,formName:'deliveryInfo'}).use(Store)
    component.mount(el)
    componentDeli.mount(elDeli)
}

